export const getPageCount = (total: number, size: number) => {
  return Math.ceil(total / size);
};

export const getPageItems = (list: any[], page: number, size: number) => {
  const offset = (page - 1) * size;
  return list.slice(offset, offset + size);
};
